import React from 'react';
import THEQUERY from './voterguide.gql';
import fetcher from 'utils/fetcher';
import '/public/css/pages/story.css';
import '/public/css/pages/voterGuides.css';
import { Body } from '@apmg/amat';
import Link from 'components/AppSafeLink/AppSafeLink';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import { linkByTypeAs } from '../../utils/cjsutils';
import { parseEmbeddedAssets } from '../../utils/utils';
import Metatags from '../../components/Metatags/Metatags';

const VoterGuide2024 = (coll) => {
  parseEmbeddedAssets(coll.results.collection.embeddedAssets);
  return (
    <>
      <Metatags
        title="2024 Minnesota General Election Voter Guide from MPR News."
        fullSlug="/voterguides/2024"
        image="https://img.apmcdn.org/019b61c4d3bb0f0b6019793942e3fb4fabe8b065/uncropped/5b033f-20240919-2024-voter-guides-1001.png"
        imageWidth={1001}
        imageHeight={201}
        description="Preparing for the upcoming election? MPR News has got you covered. Find the candidate information you need before you vote for races across Minnesota."
      />
      <ContentGrid
        h1Text={coll.results.collection.title}
        mainClassName="has-basic-links"
        sidebar={<Sidebar />}
      >
        <div className="content story-content" id="mainContent">
          <div className="voterg-body">
            <Body
              nodeData={JSON.parse(coll.results.collection.body)}
              minimal={false}
              isAmp={false}
              embedded={coll.results.collection.embeddedAssets}
            />
          </div>
          <h2>Jump to:</h2>
          <ul className="voterg-jumplinks">
            {coll.results.collection.children.items.map((topitm) => (
              <li className="type-lg" key={topitm.canonicalSlug}>
                <a href={`#${topitm.title.toLowerCase()}`}>{topitm.title}</a>
              </li>
            ))}
          </ul>
          {coll.results.collection.children.items.map((child) => {
            return (
              <section key={child.canonicalSlug} className="voterg-section">
                <h2 id={child.title.toLowerCase()}>{child.title}</h2>
                <Body
                  nodeData={JSON.parse(child.description)}
                  minimal={false}
                  isAmp={false}
                />
                <div className="voterg-section-contents">
                  {child.children.items.map((inner) => {
                    return (
                      <section key={inner.canonicalSlug}>
                        <h3>{inner.title}</h3>
                        <ul>
                          {inner.results.items.map((inner2) => {
                            return (
                              <li key={inner2.canonicalSlug}>
                                <Link href={linkByTypeAs(inner2)}>
                                  {inner2.title}
                                </Link>{' '}
                              </li>
                            );
                          })}
                        </ul>
                      </section>
                    );
                  })}
                  <ul>
                    {child.children.items.length == 0 &&
                      child.results.items.map((res) => (
                        <li key={res.canonicalSlug}>
                          <Link href={linkByTypeAs(res)}>{res.title}</Link>{' '}
                        </li>
                      ))}
                  </ul>
                </div>
              </section>
            );
          })}{' '}
        </div>
      </ContentGrid>
    </>
  );
};

export const getServerSideProps = async () => {
  const result = await fetcher(THEQUERY, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
  });
  result.collection.children.items.sort((a, b) =>
    a.title.localeCompare(b.title)
  );
  result.collection.children.items.forEach((itm) => {
    itm.children.items.sort((a, b) => a.title.localeCompare(b.title));
    itm.results.items.sort((a, b) => a.title.localeCompare(b.title));
  });
  result.collection.children.items.forEach((itm) =>
    itm.children.items.forEach((subitm) =>
      subitm.results.items.sort((a, b) => {
        const getDistrictNumber = (str) => {
          const match = str.match(/District (\d+)/);
          return match ? parseInt(match[1]) : 0;
        };

        const getDistrictLetter = (str) => {
          const match = str.match(/District \d+([A-Z])/);
          return match ? match[1] : '';
        };
        const districtNumA = getDistrictNumber(a.title);
        const districtNumB = getDistrictNumber(b.title);
        if (districtNumA === districtNumB) {
          return getDistrictLetter(a.title).localeCompare(
            getDistrictLetter(b.title)
          );
        }
        return districtNumA - districtNumB;
      })
    )
  );
  return {
    props: {
      results: result,
    },
  };
};
export default VoterGuide2024;
